"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedNavigationItem = void 0;
const react_1 = __importStar(require("react"));
const helpers_1 = require("../../../Grid/cellRenderers/helpers");
const helpers_2 = require("../../../helpers");
const NestedNavigationItem_styles_1 = require("./NestedNavigationItem.styles");
const Text_1 = require("../../../Text");
const Tooltip_1 = require("../../../Tooltip");
exports.NestedNavigationItem = react_1.default.memo((_a) => {
    var { title, isDisabled = false, isActive = false, onClick, icon } = _a, rest = __rest(_a, ["title", "isDisabled", "isActive", "onClick", "icon"]);
    const ref = (0, react_1.useRef)(null);
    return (0, Tooltip_1.useTooltip)({
        renderContent: () => react_1.default.createElement(helpers_1.TooltipText, { size: Text_1.TEXT_SIZE.s }, title),
        render: (tooltipProps) => {
            return (react_1.default.createElement(NestedNavigationItem_styles_1.StyledNestedNavigationItem, Object.assign({}, rest, { disabled: isDisabled, isActive: isActive, onClick: onClick, "aria-selected": isActive, onMouseEnter: () => {
                    (0, helpers_1.onMouseEnterHandlerDecorator)(tooltipProps.onMouseEnter, ref)();
                }, onMouseLeave: () => {
                    tooltipProps.onMouseLeave();
                }, onKeyDown: (e) => {
                    if (e.keyCode === helpers_2.KeyCode.Enter) {
                        e.stopPropagation();
                        onClick === null || onClick === void 0 ? void 0 : onClick();
                    }
                }, type: "button" }),
                icon && react_1.default.createElement(NestedNavigationItem_styles_1.StyledNestedNavigationItemIcon, { src: icon }),
                react_1.default.createElement(NestedNavigationItem_styles_1.StyledNestedNavigationItemTitle, { ref: ref, asTag: 'span', truncate: true }, title)));
        }
    });
});
exports.NestedNavigationItem.displayName = 'NestedNavigationItem';
//# sourceMappingURL=NestedNavigationItem.js.map